import { render } from "./ReminderCreateModal.vue?vue&type=template&id=35c1b9fa&scoped=true"
import script from "./ReminderCreateModal.vue?vue&type=script&lang=js"
export * from "./ReminderCreateModal.vue?vue&type=script&lang=js"

import "./ReminderCreateModal.vue?vue&type=style&index=0&id=35c1b9fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35c1b9fa"]])

export default __exports__